import { getPlanCapabilities } from '../config/plans'

/** True when capabilities map includes the named feature. */
export const hasCapability = (capabilities, key) => {
  if (!key) {
    return true
  }

  if (capabilities && typeof capabilities === 'object') {
    return Boolean(capabilities[key])
  }

  return false
}

/** Resolve capabilities from storage/usage payload or plan id. */
export const resolveCapabilities = ({ capabilities, planId } = {}) => {
  if (capabilities && typeof capabilities === 'object') {
    return capabilities
  }

  return getPlanCapabilities(planId || 'starter')
}

export default hasCapability
